(function(){

    class StandardWinCounter extends PIXI.Container{
        constructor(){
            super();
            this._FQN = undefined;
            messageBus.subscribe("spinner:GameConfigEvent", this.onLoaded.bind(this));

            this._winText = undefined;
            this._winTextShadow = undefined;
            this.visible = false;
			this.target = 0;
        }

        initialise(json){
            this._FQN = json.FQN;
        }

        onLoaded(){
            this._winTextShadow = resourceManager.get(this._FQN + ":awardTextShadow");
            this._winTextShadow.textObject.tint = 0;
            this._winText = resourceManager.get(this._FQN + ":awardText");
        }

        countTo(countTo, time){
            this.target += countTo;
			this.visible = true;
            let self = this;
			this._winTextShadow.countUp(countTo, time, function(){ self._winTextShadow.set(self.target);});
            this._winText.countUp(countTo, time, function(){ self._winText.set(self.target);});
        }

        jumpTo(total){
            this.visible = true;
			this._winTextShadow.set(total);
            this._winText.set(total);
        }

        jumpToTarget(){
            this.jumpTo(this.target);
        }

        finish(){
            this.visible = false;
            this._winTextShadow.set(0);
            this._winText.set(0);
			this.target = 0;
        }
    }

    let create = function(){
        return new StandardWinCounter();
    }

    let initialise = function(json, instance){
        instance.initialise(json);
    }

    let getRequiredFiles = function(){
        return [];
    }

    resourceManager.registerObjectType("StandardWinCounterEx", create, initialise, getRequiredFiles);
}())